// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"Select_selectWrapper__2sADZ","select":"Select_select__1IKeN"};